import { Injectable } from '@angular/core';
import { HttpTransportType, HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { ShipmentService } from './shipment.service';

@Injectable({
  providedIn: 'root',
})
export class SignalrService {
  retryTimes = [0, 1000, 5000, 30000];

  constructor() { }

  public CreateConnection(endpoint: string): HubConnection {
    return new HubConnectionBuilder()
      .withUrl(`/signalr/${endpoint}`, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (context) => {
          const index = context.previousRetryCount < this.retryTimes.length ? context.previousRetryCount : this.retryTimes.length - 1;
          let er: Error = context.retryReason;          
          return this.retryTimes[index];
        }
      })
      .build();
  }
}
